export const DEFAULT_SMOOCH_INIT_OPTIONS: Partial<InitOptions> = {
  canUserSeeConversationList: false,
  businessIconUrl:
    'https://assets.cabifil.es/images/logos_cabify/lo_cabify_avatar.svg',
  customColors: {
    brandColor: 'F2F2FA',
    conversationColor: '1A1A38',
  },
  menuItems: {
    imageUpload: true,
    fileUpload: true,
  },
};
